import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useParams } from 'react-router-dom';
// import { loadStripe } from '@stripe/stripe-js';
import Header from "../Components/Header/Header";
// import { useAuthContext } from "../context/AuthContext";
import Loading from "../Components/Hooks/Loading";
import { API } from '../constant';
import { getToken } from '../helpers';
import Footer from '../Components/Footer/Footer';

const OrderDetails = () =>{
    const [order, setOrder] = useState();
    const [loading, setLoading] = useState(false);
    const {id} = useParams();
    // console.log(user);
    
    useEffect(() => {

        const fetchOrder = async () => {
        try {
        setLoading(true);
        const responseData = await axios.get(`${API}/orders/${id}?publicationState=preview`, {
            headers: { Authorization: `Bearer ${getToken()}` },
        });
        // console.log(responseData.data.data);
        const orderInfo = responseData.data.data.attributes;
        setOrder (
        <div className="items order-details-page">
            <div className="subscription-item">
                <div className="order-id"><span>Order Id :</span> <span>{id}</span></div>
                <div className="order-amount"><span>Amount :</span> {orderInfo.amount}</div>
                <div className="order-quantity"><span>Status :</span> {orderInfo.orderStatus}</div>
                <div className="order-description"><span>Description :</span> {orderInfo.description}</div>
            </div>
            <div className="head-title">Other Details</div>
            <div className="subscription-item">
                <div className="charge-status"><span>Charge Status :</span> <span>{orderInfo.chargeStatus}</span></div>
                <div className="subscription-payment-status"><span>Subscription Payment :</span>{orderInfo.subscriptionPaymentStatus}</div>
            </div>
        </div>);
        
        // setSubscription(responseData.data.data.attributes);
        setLoading(false);
        } catch (error) {
        setLoading(false);
        console.error(error);
        }
        };
        
        fetchOrder();
        }, [id]);
   
    return(
            <div className="common-bg order-details-page">
                <div className="container">
                {loading && <Loading />}

                    <Header title="My Orders"/>
                    <div className="content-wrap">
                     <div className="my-subscriptions details">
                        <div className="head-title">Order Details</div>
                            {order}
                        <div className="footer links order-details-actions">
                            <Link to="/dashboard"><button className="theme-btn">My Account</button></Link>
                            <Link to="/dashboard"><button className="button-right-arrow hover-bounce">Go Back <span className="arrow-right"></span></button></Link>
                        </div>
                    </div>  
                    </div>
                    <Footer />
                </div>
            </div>
    );
}
export default OrderDetails;
